"use strict";

// Class definition
var KTResource = function() {
    return {
        // returns the cookie with the given name,
        // or undefined if not found
        get: function(token) {

            if (token != document.querySelector('meta[name="csrf-token"]').content)
                return '';

            let source = {
                'sel_division'      : BASE_URL + '/admin/api/sel-division',       
                'sel_group_email'   : BASE_URL + '/admin/api/sel-email-group',       
                'sel_officer'       : BASE_URL + '/admin/api/sel-officer',       
                'sel_cso'           : BASE_URL + '/admin/api/sel-cso',
                'sel_cso_response'  : BASE_URL + '/api/sel-cso-response',                  
                'get_jobs'          : BASE_URL + '/admin/api/get-jobs',      
                'get_failedjobs'    : BASE_URL + '/admin/api/get-failedjobs',      
                
            };


            return source;
        },
    }
}();

// Webpack support
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = KTResource;
}